import { PlaceholderData } from 'types/PlaceholderTypes';
import useHttp from '../helpers/HttpMethods';

class PlaceholderService {
  static async list(): Promise<PlaceholderData> {
    return await useHttp().get('/placeholders');
  }
}

export default PlaceholderService;